import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    position: 'absolute',
    right: 30,
    top: 0,
  },

}));

export default useStyles;
